import { Card, Checkbox, Flex, Popover, Space, Typography } from 'antd'
import { FC } from 'react'
import Shipment from '../../../../../types/api/shipment'
import {
    getShipmentExtraInfoLines,
    getShipmentPeopleInfoLines,
} from '../../../helpers/format-shipment-extra-info'

interface Props {
    shipment: Shipment
    /** В плане печати и на станках пока только менеджер и дизайнер */
    variant?: 'full' | 'people'
    /** Если передан — «Печать с куратором» редактируется чекбоксом */
    onChangePrintWithCurator?: (value: boolean) => void
    editable?: boolean
}

const ShipmentAdditionalInfoCell: FC<Props> = ({
    shipment,
    variant = 'full',
    onChangePrintWithCurator,
    editable = false,
}) => {
    const lines =
        variant === 'people'
            ? getShipmentPeopleInfoLines(shipment)
            : getShipmentExtraInfoLines(shipment, {
                  printWithCurator: onChangePrintWithCurator && (
                      <Checkbox
                          checked={shipment.printWithCurator}
                          disabled={!editable}
                          onChange={e => onChangePrintWithCurator(e.target.checked)}
                      />
                  ),
              })

    return (
        <Popover
            placement='left'
            mouseLeaveDelay={0.25}
            title={
                <Typography.Title style={{ marginTop: 8, marginBottom: 0 }} level={5}>
                    Дополнительная информация
                </Typography.Title>
            }
            content={
                <Card size='small' style={{ width: 300, maxWidth: 'min(360px, 92vw)' }}>
                    <Space direction='vertical' style={{ width: '100%' }} size={6}>
                        {lines.map(row => (
                            <Flex
                                key={row.label}
                                gap={16}
                                justify='space-between'
                                align='flex-start'
                                wrap='nowrap'
                            >
                                <Typography.Text type='secondary' style={{ flexShrink: 0 }}>
                                    {row.label}
                                </Typography.Text>
                                <Typography.Text
                                    style={{ textAlign: 'right', wordBreak: 'break-word' }}
                                >
                                    {row.value}
                                </Typography.Text>
                            </Flex>
                        ))}
                    </Space>
                </Card>
            }
        >
            <Typography.Text type='secondary' style={{ cursor: 'pointer' }}>
                Доп.
            </Typography.Text>
        </Popover>
    )
}

export default ShipmentAdditionalInfoCell
